import { SHContainer, SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import {
  SHDividerSkeleton,
  SHTextFieldSkeleton,
} from "@components/skeletons/design-systems";
import {
  SHFieldGroupSkeleton,
  SHFiledGroupTitleSkeleton,
} from "@components/skeletons/layouts";
import { StepName } from "@layouts/stepper/step-name";

export const PortfolioSetupSkeleton = () => {
  return (
    <SHContainer sx={{ px: { xs: "16px", lg: 0 } }}>
      <SHStack spacing={"30px"}>
        <StepName isLoading name={"Portfolio setup"} stepNumber={0} />
        <SHStack spacing={3}>
          <SHSkeleton width={80} height={26} />
          <SHSkeleton width={"100%"} height={26} />
          <SHSkeleton width={"90%"} height={26} />
        </SHStack>
        <SHDividerSkeleton />
        <SHFieldGroupSkeleton
          leftSide={<SHFiledGroupTitleSkeleton subTitleRows={3} width="50%" />}
          rightSide={
            <SHStack width={{ xs: "100%", md: 520 }} spacing={3}>
              <SHTextFieldSkeleton width="50%" />
              <SHSkeleton width={"100%"} height={54} />
            </SHStack>
          }
        />
        <SHDividerSkeleton />
        <SHFieldGroupSkeleton
          leftSide={<SHFiledGroupTitleSkeleton subTitleRows={4} width="50%" />}
          rightSide={
            <SHStack width={{ xs: "100%", md: 520 }} spacing={3}>
              <SHTextFieldSkeleton />
            </SHStack>
          }
        />
        <SHDividerSkeleton />
        <SHStack spacing={2}>
          <SHSkeleton width={80} height={26} />
          <SHSkeleton width={"80%"} height={26} />
          <SHFieldGroupSkeleton
            leftSide={
              <SHStack width={{ xs: "100%", md: 520 }} spacing={3}>
                <SHTextFieldSkeleton />
              </SHStack>
            }
            rightSide={
              <SHStack width={{ xs: "100%", md: 520 }} spacing={3}>
                <SHTextFieldSkeleton />
              </SHStack>
            }
          />
          <SHSkeleton width={"100%"} height={50} />
        </SHStack>
      </SHStack>
    </SHContainer>
  );
};
